<template>
  <div class="container cdetail" v-if="detail">
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="category">
          <a class="category-top">{{ name }}</a>
          <a class="category-bottom">{{ enname }}</a>
        </div>
      </div>
      <div
        class="panel-body"
        ref="elementtext"
        style="padding: 0px; clear: both"
        :data-heght="height"
      >
        <div v-if="flag_txt && flag" class="detailtext">
          <van-swipe class="my-swipe" :autoplay="4000" indicator-color="white">
            <van-swipe-item v-for="item in arrs"
              ><div v-html="item" class="img_plp"></div
            ></van-swipe-item>
          </van-swipe>
        </div>
        <div
          v-else
          :class="show ? 'long-text showLongText' : 'long-text hideLongText'"
          v-html="detail"
        >
          <div style="clear: both"></div>
        </div>
        <button
          type="button"
          :class="
            show
              ? 'showMore btn btn-primary btn-lg btn-block fanzhuan'
              : 'showMore btn btn-primary btn-lg btn-block'
          "
          @click="show = !show"
          v-if="height >= 400"
        ></button>
      </div>
      <div style="clear: both"></div>
    </div>
    <div style="clear: both"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      flag: false,
      show: false,
      height: 0,
      arrs: [],
    };
  },
  props: {
    detail: {
      type: String,
      require: true,
    },
    name: {
      type: String,
      require: true,
    },
    enname: {
      type: String,
      require: true,
    },
  },
  computed:{
    flag_txt() {
      if(this.name !=='游玩路线' && this.name !== '交通指引' && this.name !== '经济发展' && this.name !== '消费指南'){
        return true
      }else{
        return false
      }
    }
  },
  watch: {
    detail(val) {
      if (val && val.length > 10) {
        this.init();
      }
    },
  },
  created() {
    // console.log(this.flag);
    // console.log(this.name);
    if(this.detail && this.flag_txt && this.detail.indexOf('###') !==-1){
      this.flag = true
      this.arrs = this.detail.split("###");
    }else{
      // console.log(this.detail);
      this.flag = false
    }
    // console.log(this.arrs);
  },
  components: {},
  mounted: function () {
    this.init();
    // this.height = this.$refs.elementtext.offsetHeight
    // console.log(this.$refs.elementtext.offsetHeight)
  },
  methods: {
    init() {
      if (!this.$refs.elementtext) return;
      this.$nextTick(function () {
        let height = this.$refs.elementtext.offsetHeight;
        // console.log(height);
        this.height = height;
        let allnum = this.$refs.elementtext.getElementsByTagName("img").length;
        if (allnum == 0) return;
        let num = 0;
        let that = this;
        for (let i in this.$refs.elementtext.getElementsByTagName("img")) {
          if (
            !this.$refs.elementtext
              .getElementsByTagName("img")
              .hasOwnProperty(i)
          )
            continue;
          this.$refs.elementtext.getElementsByTagName("img")[
            i
          ].onload = function () {
            num++;
            if (allnum == num) {
              that.height = that.$refs.elementtext.offsetHeight;
            }
          };
        }
      });
    },
  },
};
</script>
<style>
.cdetail .long-text {
  padding-bottom: 10px;
}
.cdetail strong,
.cdetail strong {
  font-weight: 800;
}
.cdetail img {
  border-radius: 8px;
}
.panel-body img {
  width: 100%;
}
.long-text p span {
  font-size: 14px !important;
}
.img_plp{
  margin: 0 0 6px 0;
  padding-bottom: 10px;
}
.img_plp p span{
  font-size: 14px !important
}
 .detailtext .van-swipe__indicators{
  bottom: 6px;
}
.detailtext .van-swipe__indicator{
   background-color: rgba(61, 13, 5, .5) !important;
}
  .detailtext .van-swipe__indicators .van-swipe__indicator--active{
    background-color: rgba(61, 13, 5, .9) !important;
  }
</style>
<style scoped>

</style>
